import { queryClient } from '@services/queryClient'

import { IBarrier, IBarrierCode } from '../../interfaces/task/barrier'

export function useFindBarriersQueries() {
  async function getBarriersQuery(taskId: number) {
    await queryClient.cancelQueries({ queryKey: ['BARRIERS', taskId] })

    const [barrierQuery] = queryClient.getQueriesData<Partial<IBarrier>[]>({
      queryKey: ['BARRIERS', taskId],
      type: 'all',
    })

    return barrierQuery
  }

  async function getBarrierCodesQuery(barrierCodeId: number) {
    await queryClient.cancelQueries({ queryKey: ['BARRIER_CODES'] })

    const [barrierCodesQuery] = queryClient.getQueriesData<IBarrierCode[]>({
      queryKey: ['BARRIER_CODES'],
      type: 'all',
    })

    const [, barrierCodesResult] = barrierCodesQuery
    const barrierCode = barrierCodesResult?.find(
      (code) => code.id === barrierCodeId,
    )

    return barrierCode
  }

  return { getBarrierCodesQuery, getBarriersQuery }
}
